import { Col, Row, Slider, Container } from '@microfrontends/react-components'
import { useContext, useEffect, useState } from 'react'
import CardArticle from './CardArticle'
import Title from './Title'
import AppContext from '../../../../context/AppContext'
import getArticleFromHRInsider, {
	IArticle
} from '../../../../services/hrInsider'
import { EDevice } from '../../../../containers/MainLayout'
import { ArticleCss } from './Article.css'

export default function Article({
	isRobot,
	ssrArticles
}: {
	isRobot: boolean
	ssrArticles: IArticle[]
}) {
	const { breakpoint } = useContext(AppContext)
	const [articles, setArticles] = useState<IArticle[]>(ssrArticles)
	const [loading, setLoading] = useState(true)

	const getArticle = async () => {
		try {
			if (articles && articles.length > 0) {
				return
			}
			// hr tag id: 40950 Lộ Trình Sự Nghiệp
			const API_PATH = `${process.env.API_DOMAIN}/navi-api/api/blogs-by-hr-tag?tag_ids=40950&limit=9`
			const data = await getArticleFromHRInsider(API_PATH)

			if (data) {
				setArticles(data)
				setLoading(false)
			}
		} catch (error) {
			console.error(error)
		}
	}
	useEffect(() => {
		getArticle()
	}, [])

	return (
		<ArticleCss>
			<Container align='middle' justify='center'>
				<Title
					title='BÀI VIẾT VỀ LỘ TRÌNH SỰ NGHIỆP'
					marker='triangle'
					backgound='oval'
					backgroundColor='#fff'
				/>
				<Col>
					<Slider
						id='Slider-test-2'
						slides={{
							elementPerView:
								breakpoint !== EDevice.MOBILE ? 3 : 2
						}}
						autoEnable
						autoTime={2000}
						pagination={{ maxShow: 3 }}
						container={{ style: { width: '100%' } }}
						loadingEnable={loading}
						isRobot={isRobot}
					>
						{!articles || articles.length < 1
							? null
							: articles.map((elm, index) => {
									return (
										<CardArticle key={index} post={elm} />
									)
							  })}
					</Slider>
				</Col>
			</Container>
		</ArticleCss>
	)
}
